import { AssetAllocationId } from '@qvs/core';
import { dynamicAssetBaseMap, staticAssetBaseMap } from '~/shared/helpers/assetBaseMap';

const staticAssetColors = new Map<AssetAllocationId, string>([...staticAssetBaseMap].map(([id, data]) => [id, data.color]));
const staticAssetColorsLight: Map<AssetAllocationId, string> = new Map(
  [...staticAssetColors].map(([id, color]) => [id, `${color}-light`])
);
export const staticAssetColorMap = {
  default: staticAssetColors,
  light: staticAssetColorsLight
};

const dynamicAssetColors = new Map<AssetAllocationId, string>([...dynamicAssetBaseMap].map(([id, data]) => [id, data.color]));
const dynamicAssetColorsLight: Map<AssetAllocationId, string> = new Map(
  [...dynamicAssetColors].map(([id, color]) => [id, `${color}-light`])
);
export const dynamicAssetColorMap = {
  default: dynamicAssetColors,
  light: dynamicAssetColorsLight
};
